(() => {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  // Mobile gallery counter
  const track = section.querySelector('[data-gallery-track]');
  const current = section.querySelector('[data-gallery-current]');
  if (track && current && 'IntersectionObserver' in window) {
    const items = [...track.querySelectorAll('[data-gallery-item]')];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) current.textContent = items.indexOf(entry.target) + 1;
        });
      },
      { root: track, threshold: 0.6 }
    );
    items.forEach((item) => observer.observe(item));
  }

  const form = section.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const variantInput = form.querySelector('[data-variant-input]');
  const addButton = form.querySelector('[data-add-button]');
  const addLabel = form.querySelector('[data-add-label]');
  const status = form.querySelector('[data-form-status]');
  const priceEl = section.querySelector('[data-price]');
  const qtyInput = form.querySelector('[data-qty-input]');
  const variantData = JSON.parse(section.querySelector('[data-variant-data]')?.textContent || '{}');
  const currencyCode = priceEl?.textContent.match(/\b[A-Z]{3}\b/)?.[0];

  // Bring the selected variant's image to the front of the gallery
  function showVariantMedia(mediaId) {
    if (!mediaId || !track) return;
    const item = track.querySelector(`[data-media-id="${mediaId}"]`);
    if (!item) return;
    if (item !== track.firstElementChild) track.prepend(item);
    track.scrollTo({ left: 0, behavior: 'smooth' });
    if (current) current.textContent = 1;
  }

  const initialVariant = variantData[variantInput.value];
  if (initialVariant) showVariantMedia(initialVariant.media);

  // Quantity stepper
  form.querySelectorAll('[data-qty-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(btn.dataset.qtyStep));
      qtyInput.value = next;
    });
  });

  // Variant picker
  const picker = section.querySelector('[data-variant-picker]');
  if (picker) {
    picker.addEventListener('change', () => {
      const selected = [...picker.querySelectorAll('input[type="radio"]:checked')]
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((input) => input.value);

      picker.querySelectorAll('[data-option-value]').forEach((el) => {
        el.textContent = selected[Number(el.dataset.optionValue)] || '';
      });

      const match = Object.entries(variantData).find(([, v]) =>
        v.options.every((opt, i) => opt === selected[i])
      );

      if (!match) {
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }

      const [id, variant] = match;
      variantInput.value = id;
      showVariantMedia(variant.media);
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';

      if (priceEl) {
        const suffix = currencyCode ? ` ${currencyCode}` : '';
        priceEl.innerHTML = variant.compare
          ? `<span class="visually-hidden">Sale price</span>${variant.price}${suffix}<s class="product__compare"><span class="visually-hidden">Regular price</span>${variant.compare}</s>`
          : `${variant.price}${suffix}`;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    });
  }

  // Add to bag without leaving the page
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (addButton.disabled) return;

    const originalLabel = addLabel.textContent;
    addButton.setAttribute('aria-busy', 'true');
    addButton.disabled = true;
    addLabel.textContent = 'Adding…';
    status.className = 'product-form__status';
    status.textContent = '';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantInput.value), quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }],
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');

      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });

      status.classList.add('is-success');
      status.innerHTML = `Added to your bag. <a href="${root}checkout">Checkout</a>`;
    } catch (error) {
      status.classList.add('is-error');
      status.textContent = error instanceof SyntaxError || error instanceof TypeError
        ? 'Something went wrong. Please try again.'
        : error.message;
    } finally {
      addButton.removeAttribute('aria-busy');
      addButton.disabled = false;
      addLabel.textContent = originalLabel;
    }
  });
})();
